<template>
  <div class="global1" id="global1">   
    <canvas id='modelBox' class="modelBox"></canvas>
  </div>
</template>
<script>
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls"
import * as THREE from 'three'
export default {
  data () {
    return {
      yy: null,
      boxId: 'global1',
      width: 0,
      height: 0,
      scene: null,
      camera: null,
      renderer: null,
      container: null,
      earthRadius: 125,
      publicPath: process.env.BASE_URL,
      lineData:[
        {name: '美国', startLong: 114, startLat: 30, endLong: -62, endLat: 39, centerPoints: [4, 240, -41]},
        {name: '英国', endLong: -20, endLat: 54, startLong: 114, startLat: 30, centerPoints: [70, 160, 28]},
        {name: '德国', endLong: 50, endLat: -10, startLong: 60, startLat: 50},
        {name: '日本', endLong: 140, endLat: 38, startLong: 114, startLat: 30},
        {name: '澳大利亚', endLong: 133, endLat: -20, startLong: 114, startLat: 30},
        {name: '1', startLong: -18, startLat: -22, endLong: -62, endLat: 39},
        {name: '1', startLong: -18, startLat: -22, endLong: 60, endLat: 50},
      ],
      dotList: []
    }
  },
  created () {    
    this.lineMap1 = new THREE.TextureLoader().load(`${this.publicPath}image/line1.png`);
    this.lineMap1.wrapS = THREE.RepeatWrapping
    this.lineMap1.wrapT = THREE.RepeatWrapping
    this.lineMap1.repeat.y = 1
    this.lineMap1.rotation = Math.PI / 2;
    this.lineMap1.offset.set(0.5, 0.5);
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.width = document.getElementById(this.boxId).clientWidth
      this.height = document.getElementById(this.boxId).clientHeight
      this.scene = new THREE.Scene()    
      this.camera = new THREE.PerspectiveCamera(40, this.width/this.height, 10, 500)
      this.initRenderer()
      this.initLight()
      this.initEvent()
      this.render() 
      this.initModel()
      this.loadLine()
    },
    initRenderer () {    
      var canvas = document.getElementById('modelBox')
      canvas.width = this.width
      canvas.height = this.height
      var context = canvas.getContext( 'webgl2', { alpha: true, antialias: true } );
      this.renderer = new THREE.WebGLRenderer( { canvas: canvas, context: context } );
      this.container = canvas
      this.renderer.setSize(this.width, this.height)
      this.renderer.setPixelRatio( window.devicePixelRatio );
      this.renderer.shadowMap.enabled = true;
      
      this.camera.position.set(350,200,-200)

      this.controls = new OrbitControls(this.camera, this.container);
      this.controls.enabled = this.pageWidth < 800 ? false : true 
      this.controls.enableDamping = true
      this.controls.enablePan = false
      this.controls.enableZoom = false
      this.controls.autoRotate = true
      this.controls.autoRotateSpeed = 0.8
      this.controls.minPolarAngle = 0.3*Math.PI
      this.controls.maxPolarAngle = 0.4*Math.PI
    },
    initLight () { // 场景光    
      let light1 = new THREE.AmbientLight(0xffffff, 1.15)
      let light2 = new THREE.PointLight(0x8888EE, 0.6, 240)
      light2.position.set(220,100,0)
      light2.castShadow = true
      light2.shadow.mapSize.width = 512; // default
      light2.shadow.mapSize.height = 512; // default
      light2.shadow.camera.near = 0.5; // default
      light2.shadow.camera.far = 500;
      this.scene.add(light1) 
      this.scene.add(light2)     
    },
    initEvent () {
      window.addEventListener('resize', this.onWindowResize)
    },
    onWindowResize () {
      this.width = document.getElementById(this.boxId).clientWidth
      this.height = document.getElementById(this.boxId).clientHeight
      this.renderer.setSize(this.width, this.height)
      this.camera.aspect = this.width / this.height
      this.camera.updateProjectionMatrix()
    },
    destroyWindowResize () {
      this.scene.clear()
      this.renderer.dispose()
      this.renderer.forceContextLoss()
      this.renderer.content = null
      cancelAnimationFrame(this.animationID)
      let gl = this.renderer.domElement.getContext('webgl')
      gl && gl.getExtension('WEBGL_lose_context').loseContext()
      window.removeEventListener('resize', this.onWindowResize)
    },
    render () { // 渲染方法
      this.controls.update()
      this.renderUpdate()
      this.renderer.render(this.scene, this.camera)
      this.animationID = requestAnimationFrame(() => {this.render()})
    },
    renderUpdate () {
      if (this.lineMap1) {
        this.lineMap1.offset.y += 0.008
      }
      if (this.dotList.length > 0) {
        this.dotList.map(val => {
          val.rotate + 0.01 > 1 ? val.rotate = 0.1 : val.rotate = val.rotate + 0.01
          val.mesh.scale.set(val.rotate,val.rotate,val.rotate)
        })
      }
    },
    initModel () {
      let geo = new THREE.SphereGeometry(this.earthRadius - 2, 40, 30)
      let mat = new THREE.MeshStandardMaterial({color: 0xFFD0B0, metalness: 0.1, roughness: 0.7})
      let mesh = new THREE.Mesh(geo, mat)
      mesh.name = 'earth'
      mesh.receiveShadow = true
      this.scene.add(mesh)
      
      var map1 = new THREE.TextureLoader().load(`${this.publicPath}image/亚洲.png`)
      map1.offset.set(0.15, -0.11)
      this.mat1 = new THREE.MeshBasicMaterial({color: 0xffffff, transparent: true, map: map1, alphaTest: 1, side: THREE.DoubleSide})      
      var map2 = new THREE.TextureLoader().load(`${this.publicPath}image/欧洲.png`)
      map2.offset.set(0.15, -0.11)
      this.mat2 = new THREE.MeshBasicMaterial({color: 0xffffff, transparent: true, map: map2, alphaTest: 1, side: THREE.DoubleSide})
      var map3 = new THREE.TextureLoader().load(`${this.publicPath}image/非洲.png`)
      map3.offset.set(0.15, -0.11)
      this.mat3 = new THREE.MeshBasicMaterial({color: 0xffffff, transparent: true, map: map3, alphaTest: 1, side: THREE.DoubleSide})
      var map4 = new THREE.TextureLoader().load(`${this.publicPath}image/大洋洲.png`)
      map4.offset.set(0.15, -0.11)
      this.mat4 = new THREE.MeshBasicMaterial({color: 0xffffff, transparent: true, map: map4, alphaTest: 1, side: THREE.DoubleSide})
      var map5 = new THREE.TextureLoader().load(`${this.publicPath}image/北美洲.png`)
      map5.offset.set(0.15, -0.11)
      this.mat5 = new THREE.MeshBasicMaterial({color: 0xffffff, transparent: true, map: map5, alphaTest: 1, side: THREE.DoubleSide})
      var map6 = new THREE.TextureLoader().load(`${this.publicPath}image/南美洲.png`)
      map6.offset.set(0.15, -0.11)
      this.mat6 = new THREE.MeshBasicMaterial({color: 0xffffff, transparent: true, map: map6, alphaTest: 1, side: THREE.DoubleSide})

      let geo2 = new THREE.SphereGeometry(this.earthRadius, 40, 30)
      this.mesh2 = new THREE.Mesh(geo2, this.mat1)
      this.mesh2.renderOrder = 1
      this.scene.add(this.mesh2)

      let map = new THREE.TextureLoader().load(`${this.publicPath}image/文字层.png`)
      map.wrapS = THREE.RepeatWrapping
      map.wrapT = THREE.RepeatWrapping
      map.offset.set(0.15, -0.11)
      let geo1 = new THREE.SphereGeometry(this.earthRadius + 4, 40, 30)
      let mat1 = new THREE.MeshBasicMaterial({color: 0xffffff, transparent: true, map: map, alphaTest: 0.1, side: THREE.DoubleSide})
      let mesh1 = new THREE.Mesh(geo1, mat1)
      mesh1.renderOrder = 3
      this.scene.add(mesh1)
      
    },
    lglt2xyz (longitude,latitude,radius) { // 经纬度转成坐标点
      var lg = THREE.Math.degToRad(longitude) , lt = THREE.Math.degToRad(latitude);
      var y = radius * Math.sin(lt);
      var temp = radius * Math.cos(lt);
      var x = temp * Math.sin(lg);
      var z = temp * Math.cos(lg);
      return [x, y, z]
    },
    showbezierLine (startP, endP, centerP) { // 点到点抛物线
      let line1_material =  new THREE.MeshBasicMaterial({transparent: true, opacity: 0.8, map: this.lineMap1})
      var group = new THREE.Group()
      group.name = 'line'
      var curve = new THREE.QuadraticBezierCurve3(
        new THREE.Vector3(...startP),
        new THREE.Vector3(...centerP),
        new THREE.Vector3(...endP)
      )
      var poins = curve.getPoints(30)

      var tubeGeometry1 = new THREE.TubeBufferGeometry( new THREE.CatmullRomCurve3( poins), poins.length, 0.3, 6, false );
      let line1 = new THREE.Mesh(tubeGeometry1, line1_material)
      line1.renderOrder = 2
      
      group.add(line1)
      group.renderOrder = 4
      this.scene.add(group)
    },
    getCenterP (startLong, startLat, endLong, endLat) { // 通过起始点经纬度获取贝塞尔曲线控制点
      let x = 0, y = 0, z = 0
      let s_lat = startLat * Math.PI / 180
      let s_long = startLong * Math.PI / 180
      let e_lat = endLat * Math.PI / 180
      let e_long = endLong * Math.PI / 180
      x = (Math.cos(s_lat) * Math.cos(s_long) + Math.cos(e_lat) * Math.cos(e_long)) / 2
      y = (Math.cos(s_lat) * Math.sin(s_long) + Math.cos(e_lat) * Math.sin(e_long)) / 2
      z = (Math.sin(s_lat) + Math.sin(e_lat)) / 2
      var long = Math.atan2(y, x) * 180 / Math.PI
      var hyp = Math.sqrt(x*x + y*y)
      var lat = Math.atan2(z, hyp) * 180 / Math.PI
      var r = Math.abs(Math.sqrt(startLong * startLong + startLat * startLat) - Math.sqrt(endLong * endLong + endLat * endLat)) * 2.5
      return this.lglt2xyz(long, lat, this.earthRadius + r)
    },
    loadLine () { // 加载飞线
      let dotGeo = new THREE.PlaneGeometry( 16, 16 )
      let mat = new THREE.MeshBasicMaterial({color: 0xffffff, transparent: true, map: new THREE.TextureLoader().load(`${this.publicPath}image/circle1.png`), side: THREE.DoubleSide})
      let list = []
      this.lineData.map(val => {
        let startP = this.lglt2xyz(val.startLong, val.startLat, this.earthRadius)
        let dotP1 = this.lglt2xyz(val.startLong, val.startLat, this.earthRadius + 2) 
        let lookAt1 = this.lglt2xyz(val.startLong, val.startLat, this.earthRadius + 8)   
        let endP = this.lglt2xyz(val.endLong, val.endLat, this.earthRadius)   
        let dotP = this.lglt2xyz(val.endLong, val.endLat, this.earthRadius + 2) 
        let lookAt = this.lglt2xyz(val.endLong, val.endLat, this.earthRadius + 8)    
        let centerP = val.centerPoints || this.getCenterP(val.startLong, val.startLat, val.endLong, val.endLat)
        this.showbezierLine(startP, endP, centerP)
        let dotMesh = new THREE.Mesh(dotGeo, mat)
        let dotMesh1 = new THREE.Mesh(dotGeo, mat)
        list.push({mesh: dotMesh, rotate: 1, long: val.endLong, lat: val.endLat, position: dotP, lookAt: lookAt})
        list.push({mesh: dotMesh1, rotate: 1, long: val.startLong, lat: val.startLong, position: dotP1, lookAt: lookAt1})
      })
      this.dotList = []
      list.map(val => {
        let idx  = this.dotList.findIndex(item => {return item.long === val.long && item.lat === val.lat})
        if (idx < 0) {
          this.dotList.push(val)
        }
      })
      this.dotList.map(val => {
        val.mesh.position.set(...val.position)
        val.mesh.lookAt(...val.lookAt)
        val.mesh.renderOrder = 2
        this.scene.add(val.mesh)
      })
    },
    changeMap (idx) {
      this.mesh2.material = this[`mat${idx + 1}`]
    },
  },
  watch: {
    pageWidth () {
      if (this.pageWidth < 800) {
        if (this.controls) {
          this.controls.enabled = false
        }
      } else {
        if (this.controls) {
          this.controls.enabled = true
        }
      }
    }
  },
  beforeDestroy () {
    this.destroyWindowResize()
  }
}
</script>
<style scoped lang="stylus"> 
.global1
  width 800px
  height 800px
  position absolute
  top 10%
  left calc(50% - 100px)
  z-index 1
@media screen and (max-width: 1200px) 
  .global1
    width 15rem
    height 15rem
    top 5rem
    left calc(50% - 5rem)
@media screen and (max-width: 800px) 
  .global1
    top 6rem
    left calc(50% - 4rem)
</style>